import { DomainRegistrationUrlStatus } from '../enums/domain-registration-url-status.enum';

export const CORPORATE_DOMAIN_REGISTRATION_MEDIA_TYPE = 'application/vnd.io.idaas.admin.api.corporate.domain.registration.v1+json';

export class DomainRegistrationUrl {
  public id: string;
  public domain: string;
  public activated: boolean;
  public url: string;

  constructor(backEndRegistrationUrl?: BackendDomainRegistrationUrl) {
    if (backEndRegistrationUrl) {
      this.id = backEndRegistrationUrl.domain_id;
      this.domain = backEndRegistrationUrl.domain;
      this.activated = backEndRegistrationUrl.activated;
    }
  }

  public get status(): DomainRegistrationUrlStatus {
    return this.activated ? DomainRegistrationUrlStatus.Active : DomainRegistrationUrlStatus.Inactive;
  }

  public toBackEndPatch(): BackendDomainRegistrationUrlPatch {
    return {
      activated: this.activated,
    };
  }

  public clone(): DomainRegistrationUrl {
    const c = new DomainRegistrationUrl();
    c.id = this.id;
    c.domain = this.domain;
    c.activated = this.activated;
    c.url = this.url;
    return c;
  }

  public buildRegistrationUrl(webAppUrl: string): void {
    this.url = `${webAppUrl}/registration/${this.domain}`;
  }
}

export interface BackendDomainRegistrationUrl {
  /** The corporate domain id */
  domain_id: string;

  /** The corporate domain */
  domain: string;

  /** Whether the corporate domain can be used as registration link */
  activated: boolean;
}

export interface BackendDomainRegistrationUrlPatch {
  activated: boolean;
}
